<template>
  <div class="page">
    <div class="page-content">

      <!-- <page-nav-bar
        currentServiceName="MoneyRoad"
        subNavTitle="Negotiate a Request to Pay"
        :closePage="isSmartphone">
      </page-nav-bar> -->

  		<div class="layoutTop"/>
      <div class="container-fluid">

      <div class="row">
            <div class="col-md-10 offset-md-1">
              <i class="icon fa fa-arrow-left" style="margin-top:25px;margin-bottom:25px" @click="back()">
                <span class="ml-1 backLabel" style="font-size:large">{{ $t('common.bck') }}</span>
              </i>
              <div class="panel21 panel-default">
                <div class="panel-heading">
                    <h4 class="content-block labelAccordionForm formTitleBlock">
                        <img src='../../../assets/static/images/icons/inbox_into.png' class="formIcon"/>
                        {{ $t('requestToPay.ngtt_req_to_pay') }}
                    </h4>
                    <div class="content-block italicMandatoryIndication">
                      {{ $t('common.asterisk_obligation_label')}}
                    </div>
                </div>

                <div class="accordion-item accordionForm">
                  <a href="#" class="item-content item-link text-uppercase" :class="colorBottomButton" @click="rotateChevron($event)">
                    <div class="item-inner">
                      <div class="form-group row justify-content-start">
                          <div class="item-title createInvoiceBand col-sm-auto">
                            {{ $t('common.mdfctns') }}
                            <i class="f7-icons formChevron">chevron_right</i>
                          </div>
                      </div>
                    </div>
                  </a>
                  <div class="accordion-item-content">
                    <div class="row justify-content-start">
                      <form-write-group-label-input isMandatory
                        v-if="$settings.clickedMessage.acceptModifyAmount === '1' &&
                              $settings.clickedMessage.status === status.WAITING"
                        :inputLabel="$t('common.total_amount_no_currency')" :placeholderValue="totalAmountLabel"
                        v-model="newAmount" :inputType="'number'" @input="checkSum">
                      </form-write-group-label-input>
                      <form-read-group-label-input v-else
                        :inputLabel="$t('common.total_amount_no_currency')"
                        :inputValue="newAmount + ' ' + getCcy($settings.clickedMessage.currency)">
                      </form-read-group-label-input>
                      <div class="form-group col-sm-6">
                        <label>
                          {{ $t('common.installment_number') }}
                        </label> <span class="color-red">* </span>
                        <select
                          class="form-control"
                          v-model="payNumber"
                          @change="defineArray(payNumber)">
                          <option v-for="n in 6" v-if="n >= getMinInstallments" :value="n">{{n}}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="accordion-item accordionForm">
                  <a href="#" class="item-content item-link text-uppercase" :class="colorBottomButton" @click="rotateChevron($event)">
                    <div class="item-inner">
                      <div class="form-group row justify-content-start">
                          <div class="item-title createInvoiceBand col-sm-auto">
                            {{ $t('common.dts_nd_amnts') }}
                            <i class="f7-icons formChevron">chevron_right</i>
                          </div>
                      </div>
                    </div>
                  </a>

                  <div class="accordion-item-content hasDatePicker">
                    <div class="row form-group justify-content-start" v-if="!immediate" v-for="(n, index) in multPmts" :key="index">
                      <form-write-group-label-input inputType="date" :formGroupWidth="'6 col-7'" disablePastDates
                        :inputLabel="$t('common.installment_date')" v-model="payDate[index]">
                      </form-write-group-label-input>
                      <form-write-group-label-input :formGroupWidth="'6 col-5'" :isMandatory="true"
                          :inputLabel="$t('common.amnt')" :placeholderValue="amountCurrency"
                          v-model="n.amount" :inputType="'number'">
                      </form-write-group-label-input>
                    </div>
                    <div class="form-group row">
                      <div class='col-sm-12'>
                        <div v-if="!immediate" style="font-weight: bold; width: 100%; text-align:right;">
                          {{ $t('regles_metier.rqstng') }}
                          <font :color="sumColor">{{sum + ccy}}</font>
                          {{ $t('common.of_label') }}
                          <font color="#12bcf1">{{newAmount + ccy}}</font>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-sm-12">
                        <label>
                          {{ $t('common.general_comment') }}
                        </label>
                        <textarea style="font-size: 12px;" class="form-control" v-model="negotiationComment">
                      	</textarea>
                      </div>
                    </div>
                  </div>
                </div>
    </div>
  </div>
</div>
  <div class="row justify-content-start">
    <div class="col-md-3 offset-md-1">
      <button round
      v-if="$settings.clickedMessage.pay !== 'none' &&
            ($settings.clickedMessage.status === status.WAITING || $settings.clickedMessage.status === status.MODIFIED)"
      class="button-action firstButtonMarginTop milkyBlockBlack"
      @click="submitToNegotiate('1')">
        <i class="icon fa fa-paper-plane"></i>
        {{ $t('common.accpt_nd_pay') }}
      </button>
    </div>
    <div class="col-md-3 offset-md-4">
      <button round
      class="button-action firstButtonMarginTop milkyBlockBlack"
      @click="submitToNegotiate('0')">
      <i class="icon fa fa-paper-plane"></i>
        {{ $t('common.accpt') }}
      </button>
    </div>
  </div>
      <div class="toolbarPageBottomBlank"></div>
    </div>
  </div>
  </div>
</template>

<script>
// import {post} from '@/helpers/api'
import moment from 'moment'
import {errorMessageAlert} from '@/helpers/alert'
import pageNavBar from '@/components/common/pageNavBar.vue'
import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'
import datePickerMixin from '@/mixins/datePickerMixin'
import Datepicker from 'vuejs-datepicker'
import {loadPage, reloadPage, pageBack} from '@/helpers/routing'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import _ from 'lodash'
import status from '@/helpers/status'

export default {
  mixins: [datePickerMixin],
  name: 'TransactionEdit',
  components: {
    'page-nav-bar': pageNavBar,
    'bottom-toolbar': bottomToolbar,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'form-read-group-label-input': formReadGroupLabelInput,
    'date-picker': Datepicker
  },
  computed: {
    sum: function () {
      let sum = 0
      for (let i = 0; i < this.multPmts.length; i++) {
        sum += this.multPmts[i].amount === '' ? 0 : parseFloat(this.multPmts[i].amount)
      }
      return sum
    },
    getMinInstallments: function () {
      switch (this.$settings.clickedMessage.status) {
        case '2' :
        case '13' :
        case '14' :
          // we count using the "pay" instead of the date
          // if the date is passed, the status is supposed to be "expired"
          let i = 0
          while (i < this.multPmts.length) {
            if (this.multPmts[i].pay === '1') {
              i++
            } else {
              // you have to modify more than the paid number
              return i + (i === 0 ? 2 : 1)
            }
          }
          // if we arrive at the end of the loop, the status should be "expired"
          return i
        default:
          return '2'
      }
    }
  },
  data () {
    return {
      isSmartphone: false,
      payNumber: 0,
      multPmts: [],
      payDate: [],
      payAmount: [],
      newAmount: 0,
      sumColor: 'red',
      amountChanged: false,
      immediate: false,
      ccy: '',
      negotiationComment: '',
      colorBottomButton: this.$engine.services.getButtonClassColorById(this.$engine.user.currentService.id),
      totalAmountLabel: this.$i18n.t('common.total_amount', {currency: this.$i18n.t('common.current_currency')}),
      amountCurrency: this.$i18n.t('common.amnt_with_currency', {currency: this.$i18n.t('common.current_currency')}),
      status: status
    }
  },
  watch: {
    sum (val) {
      if (Number(val) === Number(this.newAmount)) {
        this.sumColor = '#12bcf1'
      } else {
        this.sumColor = 'red'
      }
    },
    multPmts: {
      handler: function () {
        let sum = 0
        for (let i = 0; i < (this.multPmts.length - 1); i++) {
          sum += this.multPmts[i].amount > 0 ? parseFloat(this.multPmts[i].amount) : 0.0
        }
        this.multPmts[this.multPmts.length - 1].amount = this.newAmount - sum >= 0 ? this.newAmount - sum : 0
      },
      deep: true
    }
  },
  created () {
    let that = this
    if (that.$engine.services.directPayments.filter.smartphoneStorage) {
      that.isSmartphone = true
    }
    if (that.$settings.clickedMessage.status === status.WAITING) {
      that.multPmts = []
      that.multPmts.push({date: moment().format('YYYY-MM-DD'), amount: 0})
      that.multPmts.push({date: that.$settings.clickedMessage.requestedExecutionDate, amount: that.$settings.clickedMessage.amount})
      that.payNumber = 2
      that.payDate = []
      that.payDate.push(that.$settings.clickedMessage.requestedExecutionDate)
      that.payDate.push(that.$settings.clickedMessage.requestedExecutionDate)
      that.payAmount = []
      that.payAmount.push(0)
      that.payAmount.push(that.$settings.clickedMessage.amount)
      // that.sum = that.$settings.clickedMessage.amount
      that.newAmount = that.$settings.clickedMessage.amount
    } else {
      that.multPmts = _.cloneDeep(that.$settings.clickedMessage.pmtResp.multPmts)
      that.payNumber = that.multPmts.length
      that.payDate = []
      that.payAmount = []
      for (var i = 0; i < that.multPmts.length; i++) {
        that.payDate.push(that.multPmts[i].date)
        that.payAmount.push(that.multPmts[i].amount)
      }
      // that.sum = that.$settings.clickedMessage.pmtNegot.amountDebtor
      that.newAmount = that.$settings.clickedMessage.amountResponse
    }
    that.amountChanged = false
    that.ccy = that.getCcy(that.$settings.clickedMessage.currency)
    that.immediate = false
  },
  mounted () {
    /* TLV 23/06/2020
    * Sur toutes les tailles d'écran, les accordéons sont étendus par défaut
    */
    this.$$('.accordionForm').addClass('accordion-item-expanded')
    this.$$('.formChevron').transform('rotate(90deg)')
  },
  methods: {
    back () {
      pageBack(this)
    },
    getCcy (ccy) {
      switch (ccy) {
        case 'EUR':
          return '€'
        case 'USD':
          return '$'
        case 'GBP':
          return '£'
        case 'JPY':
          return '¥'
        case 'RUB':
          return '₽'
        default:
          return this.$settings.clickedMessage.currency
      }
    },
    defineArray (n) {
      if (n > 100) {
        n = 100
        this.payNumber = 100
      }
      while (this.multPmts.length < n) {
        this.payDate.push(moment(this.$settings.clickedMessage.reqstdExecDt).format('YYYY-MM-DD'))
        this.payAmount.push('0')
        this.multPmts.push({
          date: this.$settings.clickedMessage.reqstdExecDt,
          amount: '0'
        })
      }
      while (this.multPmts.length > n) {
        this.payDate.pop()
        this.payAmount.pop()
        this.multPmts.pop()
      }
    },
    checkSum () {
      if (this.sum !== this.newAmount) {
        this.sumColor = 'red'
      } else {
        this.sumColor = '#12bcf1'
      }
    },
    rotateChevron ($event) {
      if (this.Dom7($event.target).parent().parent().parent().parent().hasClass('accordion-item-expanded') ||
          this.Dom7($event.target).parent().parent().parent().hasClass('accordion-item-expanded') ||
          this.Dom7($event.target).parent().parent().hasClass('accordion-item-expanded') ||
          this.Dom7($event.target).parent().hasClass('accordion-item-expanded')) {
        this.Dom7($event.target).find('i').transform('rotate(0deg)')
      } else {
        this.Dom7($event.target).find('i').transform('rotate(90deg)')
      }
    },
    getColor () {
      if (Number(this.sum) === Number(this.newAmount)) {
        return 'green'
      } else {
        return 'red'
      }
    },
    submit () {
      let multiplePayments = []
      let execDate = ''
      let today = moment().format('YYYY-MM-DD')
      if (!this.immediate) {
        if (this.multPmts.length === 0) {
          this.$f7.alert(this.$i18n.t('errors.chs_dt_of_pymnt'), this.$i18n.t('errors.invld'))
          return
        } else if (this.sum !== Number(this.newAmount)) {
          this.$f7.alert(this.$i18n.t('errors.sum_not_eq_to_total'), this.$i18n.t('erros.invld'))
          return
        }
        multiplePayments = this.multPmts
        execDate = this.multPmts[this.multPmts.length - 1].date
      } else {
        multiplePayments = []
        execDate = today
      }
      let that = this
      that.$engine.services.payments.answerToPayments(that.$settings.clickedMessage.id, '2', Number(this.newAmount), execDate, that.immediate, multiplePayments)
        .then(response => {
          if (response.status === 200) {
            that.$f7.alert('', this.$i18n.t('common.status.transaction_accepted'), function () {
              that.$f7.closeModal()
              loadPage(that, {url: '/inbox/0'})
            })
          }
        })
        .catch(error => {
          errorMessageAlert(error, that)
        })
    },
    controlParams (that) {
      for (let i = 0; i < that.multPmts.length; i++) {
        if (!that.payDate[i]) {
          this.$f7.alert(this.$i18n.t('errors.chs_dt_of_pymnt'), this.$i18n.t('errors.invld'))
          return false
        } else if (that.$settings.clickedMessage.acceptModifyExecutionDate === '0' &&
            moment(that.payDate[i]).format('YYYY-MM-DD') > moment(that.$settings.clickedMessage.requestedExecutionDate).format('YYYY-MM-DD')) {
          this.$f7.alert(this.$i18n.t('errors.chs_dt_of_pymnt'), this.$i18n.t('errors.invld'))
          return false
        } else if (!that.multPmts[i].amount || that.multPmts[i].amount === '0') {
          this.$f7.alert(this.$i18n.t('errors.sum_not_eq_to_total'), this.$i18n.t('errors.invld'))
          return false
        } else {
          that.multPmts[i].date = moment(that.payDate[i]).format('YYYY-MM-DD')
        }
      }
      if (Number(this.sum) !== Number(this.newAmount)) {
        this.$f7.alert(this.$i18n.t('errors.sum_not_eq_to_total'), this.$i18n.t('errors.invld'))
        return false
      }
      return true
    },
    submitToNegotiate (payStatus) {
      let that = this
      if (!this.controlParams(that)) {
        return
      }
      let multiplePayments = []
      let execDate = this.$settings.clickedMessage.acceptModifyExecutionDate === '1'
                      ? this.multPmts[this.multPmts.length - 1].date
                      : this.$settings.clickedMessage.requestedExecutionDate
      let status = '2'
      multiplePayments = this.multPmts
      let uniqueExecutionDate = []
      let flagUniqueExecutionDate = true
      for (let i = 0; i < multiplePayments.length; i++) {
        if (uniqueExecutionDate.includes(multiplePayments[i].date)) {
          flagUniqueExecutionDate = false
        } else {
          uniqueExecutionDate.push(multiplePayments[i].date)
        }
      }
      if (flagUniqueExecutionDate === false) {
        this.$f7.alert(this.$i18n.t('errors.instllmnts_dt_shld_nt_be_sm'), this.$i18n.t('errors.invld'))
        return
      }

      for (let i = 0; i < this.multPmts.length; i++) {
        this.multPmts[i].currency = this.$settings.clickedMessage.currency
      }
      // execDate = this.multPmts[0].date
      // let negotiationType = ''
      // let negotiationDecision = ''
      if (that.$settings.clickedMessage.negotStatus === '0') {
        // negotiationType = 'negotRqst'
        // negotiationDecision = 'OK'
      } else if (that.$settings.clickedMessage.negotStatus === '10') {
        // negotiationType = 'negotResp'
        // negotiationDecision = 'MODIF'
      }
      if (this) {
        // console.log('test')
        // console.log(that.$settings.clickedMessage)
        // console.log(that.$settings.clickedMessage.id)
        // console.log(that.$settings.clickedMessage.negotStatus)
        // console.log(Number(this.newAmount))
        // console.log(that.$settings.clickedMessage.currency)
        // console.log(this.multPmts[0].date)
        // console.log(this.negotiationComment)
        // console.log(this.$settings.clickedMessage.debtorBankAccount)
        // console.log(that.$engine.settings.get().isToGenerateXML)
        // console.log(this.$settings.clickedMessage.instantPayment)
        // console.log('0')
        // console.log(execDate)
      }
      that.$engine.services.payments.answerToPayments(
        that.$settings.clickedMessage.id,
        status,
        Number(this.newAmount),
        that.$settings.clickedMessage.currency,
        execDate,
        this.negotiationComment,
        this.$settings.clickedMessage.debtorBankAccount,
        that.$engine.settings.get(1).isToGenerateXML,
        this.$settings.clickedMessage.instantPayment,
        this.multPmts,
        payStatus
      ).then(response => {
        this.negotiationComment = ''
        if (response.status === 200) {
          let textAlert = ''
          if (that.$settings.clickedMessage.negotStatus === '0') {
            textAlert = this.$i18n.t('common.status.negotiation_request_sent')
          } else if (that.$settings.clickedMessage.negotStatus === '10') {
            textAlert = this.$i18n.t('common.status.negotiation_response_sent')
          } else {
            textAlert = ''
          }
          that.$f7.alert('', textAlert, function () {
            that.$f7.closeModal()
            reloadPage(that, {url: '/inbox/0'})
          })
        }
      }).catch(error => {
        errorMessageAlert(error, that)
      })
    },
    calendar ($event, index) {
      /* eslint-disable no-undef */
      let that = this
      if (that.$f7.device.os === 'android' || that.$f7.device.os === 'ios') {
        var options = {
          date: moment(),
          mode: 'date'
        }
        datePicker.show(options, function (date) {
          let year = date.getFullYear().toString()
          let month = (date.getMonth() + 1).toString().length > 1 ? (date.getMonth() + 1).toString() : '0' + (date.getMonth() + 1).toString()
          let day = date.getDate().toString().length > 1 ? date.getDate().toString() : '0' + date.getDate().toString()
          let dateResult = year + '-' + month + '-' + day
          that.payDate[index] = dateResult
          that.multPmts[index].date = dateResult
          // that.Dom7($event.target).val(dateResult)
          that.Dom7($event.target).text(dateResult)
        })
      }
      /* eslint-enable no-undef */
    },
    paymentsDate (index) {
      if (this.payDate[index] !== undefined) {
        if (this.payDate[index].length > 0) {
          return this.payDate[index]
        } else {
          return this.$i18n.t('common.slct_date')
        }
      } else {
        return this.$i18n.t('common.slct_date')
      }
    }
  }
}
</script>

<style>
#paymentsModification .item-title.label {
	overflow: initial;
  white-space: initial;
}
</style>
